import React from 'react';
import { Admin, Resource } from 'react-admin';

import { i18nProvider } from '~config/i18n';
import authProvider from '~config/providers/authProvider';
import dataProvider from '~config/providers/dataProvider';
import CustomLayout from '~components/CustomLayout';
import AccionList from '~screens/Acciones/AccionList';
import AccionCreate from '~screens/Acciones/AccionCreate';
import AccionEdit from '~screens/Acciones/AccionEdit';
import AccionShow from '~screens/Acciones/AccionShow';
import AccionBorradorList from '~screens/AccionesBorrador/AccionBorradorList';
import AccionBorradorCreate from '~screens/AccionesBorrador/AccionBorradorCreate';
import AccionBorradorEdit from '~screens/AccionesBorrador/AccionBorradorEdit';

import '../scss/quillOverrides.scss';
import '../scss/typography.scss';

import styles from './styles.module.scss'; // eslint-disable-line no-unused-vars
import { appTheme } from './styles';
import Login from './screens/Login';
import TerritorioList from "~screens/Territorios/TerritorioList";
import TerritorioCreate from "~screens/Territorios/TerritorioCreate";
import TerritorioShow from "~screens/Territorios/TerritorioShow";
import TerritorioEdit from "~screens/Territorios/TerritorioEdit";
import PriorizacionList from "~screens/Priorizaciones/PriorizacionList";
import PriorizacionCreate from "~screens/Priorizaciones/PriorizacionCreate";
import PriorizacionEdit from "~screens/Priorizaciones/PriorizacionEdit";
import DisclaimerList from "~screens/Disclaimers/DisclaimerList";
import DisclaimerCreate from "~screens/Disclaimers/DisclaimerCreate";
import DisclaimerEdit from "~screens/Disclaimers/DisclaimerEdit";
import EtapaList from "~screens/Etapas/EtapaList";
import EtapaEdit from "~screens/Etapas/EtapaEdit";
import {CatalogList, CatalogCreate, CatalogEdit} from "~screens/Catalogs";
import {FuenteList, FuenteCreate, FuenteEdit} from "~screens/Fuentes";
import {SubtemaCategoriaList, SubtemaCategoriaCreate, SubtemaCategoriaEdit} from "~screens/SubtemaCategorias";
import {EstudioList, EstudioCreate, EstudioEdit} from "~screens/Estudios";
import FinanciadorEstudiosList from "~screens/FinanciadoresEstudios/FinanciadorEstudiosList";
import FinanciadorEstudiosEdit from "~screens/FinanciadoresEstudios/FinanciadorEstudiosEdit";
import FinanciadorEstudiosCreate from "~screens/FinanciadoresEstudios/FinanciadorEstudiosCreate";
import SubtemaList from "~screens/Subtemas/SubtemaList";
import SubtemaEdit from "~screens/Subtemas/SubtemaEdit";
import SubtemaCreate from "~screens/Subtemas/SubtemaCreate";
import PaisList from "~screens/Paises/PaisList";
import PaisEdit from "~screens/Paises/PaisEdit";
import PaisCreate from "~screens/Paises/PaisCreate";
import MetricList from "~screens/Metrics/MetricList";
import MetricCreate from "~screens/Metrics/MetricCreate";
import MetricEdit from "~screens/Metrics/MetricEdit";
import MetricValueList from "~screens/MetricValues/MetricValueList";
import MetricValueCreate from "~screens/MetricValues/MetricValueCreate";
import MetricValueEdit from "~screens/MetricValues/MetricValueEdit";
import LayersList from "~screens/Layers/LayersList";
import LayerCreate from "~screens/Layers/LayerCreate";

function App() {
  return (
    <Admin
      theme={appTheme}
      locale="es"
      i18nProvider={i18nProvider}
      dataProvider={dataProvider}
      authProvider={authProvider}
      appLayout={CustomLayout}
      loginPage={Login}
    >
      <Resource name={'territories'} list={TerritorioList} create={TerritorioCreate} show={TerritorioShow} edit={TerritorioEdit}/>
      <Resource
        name="actions"
        show={AccionShow}
        list={AccionList}
        create={AccionCreate}
        edit={AccionEdit}
      />
      <Resource
        name="draft-actions"
        options={{ label: 'Acciones (Borrador)' }}
        list={AccionBorradorList}
        create={AccionBorradorCreate}
        edit={AccionBorradorEdit}
      />
      <Resource
        name="priorizaciones"
        list={PriorizacionList}
        create={PriorizacionCreate}
        edit={PriorizacionEdit}
      />
      <Resource
        name="disclaimers"
        list={DisclaimerList}
        create={DisclaimerCreate}
        edit={DisclaimerEdit}
      />
      <Resource name="studies" list={EstudioList} create={EstudioCreate} edit={EstudioEdit} />
      <Resource
        name="etapas"
        list={EtapaList}
        edit={EtapaEdit}
      />
      <Resource name="scopes" list={CatalogList} edit={CatalogEdit} create={CatalogCreate} />
      <Resource name="terms" list={CatalogList} edit={CatalogEdit} create={CatalogCreate} />
      <Resource name="sources" list={FuenteList} edit={FuenteEdit} create={FuenteCreate} />
      <Resource name="financiadores-estudios" list={FinanciadorEstudiosList} edit={FinanciadorEstudiosEdit} create={FinanciadorEstudiosCreate} />
      <Resource name="types" list={CatalogList} edit={CatalogEdit} create={CatalogCreate} />
      <Resource name="themes" list={CatalogList} edit={CatalogEdit} create={CatalogCreate} />
      <Resource name="subthemes" list={SubtemaList} edit={SubtemaEdit} create={SubtemaCreate} />
      <Resource name="chart-categories" list={CatalogList} edit={CatalogEdit} create={CatalogCreate} />
      <Resource name="subtheme-categories" list={SubtemaCategoriaList} edit={SubtemaCategoriaEdit} create={SubtemaCategoriaCreate} />
      <Resource name="paises" list={PaisList} edit={PaisEdit} create={PaisCreate} />
      <Resource name="metrics" list={MetricList} create={MetricCreate} edit={MetricEdit} />
      <Resource name="metric-values" list={MetricValueList} create={MetricValueCreate} edit={MetricValueEdit} />
      <Resource name="layers" list={LayersList} create={LayerCreate} />
      <Resource name="countries" />
    </Admin>
  );
}

export default App;
